import React from 'react';

import { BaseMotionTokenTable, type MotionTokenTableValue } from '../base-table';

const values: MotionTokenTableValue[] = [
	{
		tokenName: 'motion.avatar.hovered',
		component: 'Avatar',
	},
	{
		tokenName: 'motion.avatar.pressed',
	},
	{
		tokenName: 'motion.tab',
		component: 'Tabs',
	},
];

/**
 * __Interactions table__
 */
export const MotionInteractionsTable = (): React.JSX.Element => {
	return <BaseMotionTokenTable values={values} testId="motion-interactions-table" />;
};
